import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const breakPoint = 1024;

export function swiperFunc() {
    initSlider05();
    initSlider06();
    initSlider07();
    initSlider08();
    initSlider11();
    initSlider14();
}

function initSlider05() {
    let slider;
    const sliderClass = '.section-05-slider';
    const sliderOptions = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 'auto',
        loop: true,
    };

    // スマホだけスライダー化（初期表示）
    if (window.innerWidth < breakPoint) {
        slider = new Swiper(sliderClass, sliderOptions);
    } else {
        slider = undefined;
    }

    // スマホだけスライダー化（リサイズ時）
    window.addEventListener('resize', () => {
        if (window.innerWidth < breakPoint) {
            if(slider) return;
            slider = new Swiper(sliderClass, sliderOptions);
        } else {
            if(!slider) return;
            slider.destroy();
            slider = undefined;
        }
    }, false);
}

function initSlider06() {
    const sliderClass = '.section-06-slider';
    const sliderOptions = {
        spaceBetween: 0,
        slidesPerView: 3,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
        },
        loop: true,
        breakpoints: {
            500: {
                slidesPerView: 5,
            },
            1024: {
                slidesPerView: 6,
            },
            1600: {
                slidesPerView: 8,
            }
        },
    };

    const slider = new Swiper(sliderClass, sliderOptions);
}

function initSlider07() {
    let slider;
    const sliderClass = '.section-07-slider';
    const sliderOptions = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        loop: true,
    };

    // スマホだけスライダー化（初期表示）
    if (window.innerWidth < breakPoint) {
        slider = new Swiper(sliderClass, sliderOptions);
    } else {
        slider = undefined;
    }

    // スマホだけスライダー化（リサイズ時）
    window.addEventListener('resize', () => {
        if (window.innerWidth < breakPoint) {
            if(slider) return;
            slider = new Swiper(sliderClass, sliderOptions);
        } else {
            if(!slider) return;
            slider.destroy();
            slider = undefined;
        }
    }, false);
}

function initSlider08() {
    const sliderClass = '.section-08-slider';
    const sliderOptions = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 60,
            },
        },
    };

    const slider = new Swiper(sliderClass, sliderOptions);
}

function initSlider11() {
    let slider;
    const sliderClass = '.section-11-slider';
    const sliderOptions = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 40,
        slidesPerView: 'auto',
        loop: true,
    };

    // スマホだけスライダー化（初期表示）
    if (window.innerWidth < breakPoint) {
        slider = new Swiper(sliderClass, sliderOptions);
    } else {
        slider = undefined;
    }

    // スマホだけスライダー化（リサイズ時）
    window.addEventListener('resize', () => {
        if (window.innerWidth < breakPoint) {
            if(slider) return;
            slider = new Swiper(sliderClass, sliderOptions);
        } else {
            if(!slider) return;
            slider.destroy();
            slider = undefined;
        }
    }, false);
}

function initSlider14() {
    let slider;
    const sliderClass = '.section-14-slider';
    const sliderOptions = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 80,
        slidesPerView: 'auto',
        loop: true,
    };

    // スマホだけスライダー化（初期表示）
    if (window.innerWidth < breakPoint) {
        slider = new Swiper(sliderClass, sliderOptions);
    } else {
        slider = undefined;
    }

    // スマホだけスライダー化（リサイズ時）
    window.addEventListener('resize', () => {
        if (window.innerWidth < breakPoint) {
            if(slider) return;
            slider = new Swiper(sliderClass, sliderOptions);
        } else {
            if(!slider) return;
            slider.destroy();
            slider = undefined;
        }
    }, false);
}